import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import { SendPostRequest } from "../http";
import Spinner from "./Spinner";
import { useSelector } from "react-redux";

export default function ServicesList() {
  const { id } = useParams();
  const { slug } = useParams();
  const [servicesDetail, setServicesDetail] = useState({});
  const [servicesList, setServicesList] = useState([]);
  const [loading, setLoading] = useState(true);

  const sitedata = useSelector((store) => store.global.loginData);

  useEffect(() => {
    window.scrollTo(0, 0);
    getServicesDetail();
  }, [id]);

  const getServicesDetail = async () => {
    try {
      setLoading(true);
      const response = await SendPostRequest("services/detail", {
        service_uid: id,
        // slug: slug,
      });

      if (response.status === "success") {
        setServicesList(response.data.lists);
        setServicesDetail(response.data.detail);
      } else {
        console.warn("No service detail found in the response.");
      }
    } catch (error) {
      console.error("Error fetching services detail:", error);
    } finally {
      setLoading(false);
    }
  };

  const [backgroundImage, setBackgroundImage] = useState("");
  useEffect(() => {
    let themeColor;
    if (sitedata) {
      themeColor = sitedata?.theme_color?.split(".css").join("");
    } else {
    }

    setBackgroundImage(`/assets/img/doctors/banner_bg_${themeColor}.svg`);
  }, [sitedata?.theme_color]);

  return (
    <>
      <Header />
      <section
        className="cs_banner cs_style_5 cs_bg_filed"
        // style={{
        //   backgroundImage:
        //     sitedata.site_type === "hospitals"
        //       ? "url('/assets/img/doctors/banner_bg.svg')"
        //       : "url('/assets/img/doctors/banner_bg_gold.svg')",
        // }}
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        {/* <div className="cs_banner_img">
          <img src="/assets/img/doctors/banner_img.png" alt="Banner" />
        </div> */}
        <div className="container">
          <div className="">
            <h2 className="cs_banner_title cs_fs_65">
              {servicesDetail?.service_title}
            </h2>
          </div>
        </div>
      </section>
      <div className="container">
        <ol className="breadcrumb">
          {/*<li className="breadcrumb-item"><a href="index.html">Home</a></li>*/}
          {/*<li className="breadcrumb-item"><a href="blog.html">Blog</a></li>*/}
          {/*<li className="breadcrumb-item active">*/}
          {/*</li>*/}
        </ol>
        <div className="cs_height_35"></div>
        {/* <h1 className="cs_fs_72 mb-0">Parent Care Package</h1> */}
        {/* <h2>{servicesDetail?.service_title}</h2> */}
        <div className="cs_height_20"></div>
        <div className="row">
          <div className="col--lg-8 col-md-8 col-12 mobile_view_blogs">
            {loading ? (
              <div className="d-flex align-items-center justify-content-center">
                <Spinner />
              </div>
            ) : (
              <>
                {/* <div
                  className="services-detail-img"
                  style={{
                    backgroundImage: `url(data:image/jpeg;base64,${servicesDetail?.service_image})`,
                    backgroundPosition: "center center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    height: "300px",
                    width: "400px",
                  }}
                ></div> */}
                <img
                  src={servicesDetail?.service_image_url}
                  alt="Blog Details"
                  className=" cs_radius_20 services-detail-img mb-4"
                />
                <div className="cs_blog_details">
                  {/* <p>{servicesDetail?.service_description}</p> */}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: servicesDetail?.service_description,
                    }}
                  />
                </div>
                <div className="cs_height_92"></div>
              </>
            )}
          </div>
          <div className="col-lg-4 col-md-4 d-none d-lg-block">
            <div className="cs_sidebar services_cs_scroll_sidebar">
              <div className="cs_sidebar_item service-detail-list">
                <h2 className="cs_sidebar_widget_title">Other Services</h2>
                {loading ? (
                  <div className="d-flex align-items-center justify-content-center">
                    <Spinner />
                  </div>
                ) : servicesList?.length > 0 ? (
                  <ul>
                    {servicesList.map((list, index) => (
                      <li key={index}>
                        <img src={list?.service_image_url} alt="Service" />
                        <Link
                          to={`/service/${list?.uid}/${list?.service_title
                            .replaceAll(" ", "-")
                            .replaceAll("/", "-")}`}
                        >
                          {list?.service_title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No other services found.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cs_height_42 cs_height_xl_25"></div>
      <Footer />
    </>
  );
}
